function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChallengeSummaryTiles = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _View = require("../View");
var _ValueBox = require("../ValueBox");
var _SvgImage = require("../SvgImage");
var _useLang = require("./useLang");
var _reactI18next = require("react-i18next");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var ChallengeSummaryTiles = exports.ChallengeSummaryTiles = function ChallengeSummaryTiles(_ref) {
  var participantsCount = _ref.participantsCount,
    pendingCommitmentsCount = _ref.pendingCommitmentsCount,
    successfulCommitmentsCount = _ref.successfulCommitmentsCount,
    style = _ref.style;
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var ParticipantsImage = (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, Object.assign({
      image: require("../../images/HandsHoldingHearts.svg")
    }, props));
  });
  var ActivityImage = (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, Object.assign({
      image: require("../../images/ShoeYellowRed.svg")
    }, props));
  });
  var CompletedImage = (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, Object.assign({
      image: require("../../images/ShoeRed.svg")
    }, props));
  });
  return (0, _jsxRuntime.jsxs)(_View.View, {
    style: [styles.summaryGrid, style],
    testID: "ChallengeSummaryTiles",
    children: [(0, _jsxRuntime.jsx)(_ValueBox.ValueBox, {
      value: participantsCount || 0,
      label: t('challengeSummaryTiles:participants.title'),
      description: t('challengeSummaryTiles:participants.description'),
      Image: ParticipantsImage,
      style: styles.summaryGridItem,
      imageContainerStyle: {
        width: 80,
        height: 80
      },
      imageStyle: {
        width: 80 * 1.6,
        marginLeft: 20 * 1.6 * -1,
        marginTop: 5 * 1.6 * -1
      }
    }), (0, _jsxRuntime.jsx)(_ValueBox.ValueBox, {
      value: pendingCommitmentsCount || 0,
      label: t('challengeSummaryTiles:activity.title'),
      description: t('challengeSummaryTiles:activity.description'),
      Image: ActivityImage,
      style: styles.summaryGridItem,
      imageContainerStyle: {
        width: 116,
        height: 80
      }
    }), (0, _jsxRuntime.jsx)(_ValueBox.ValueBox, {
      value: successfulCommitmentsCount || 0,
      label: t('challengeSummaryTiles:completed.title'),
      description: t('challengeSummaryTiles:completed.description'),
      Image: CompletedImage,
      style: styles.summaryGridItem,
      imageContainerStyle: {
        width: 67,
        height: 80
      }
    })]
  });
};